
<template>
  <button class="btncomponent" v-on:click="navigate()">{{label}}</button>
</template>
<script>
export default {
    props: {
        label: String,
        href: String,
        route: String
    },
    methods: {
        navigate() {
            if (this.route) {
                this.$router.push(this.href);
            } else {
                window.location.replace(this.href);
            }
            
        }
    }
}
</script>
<style lang="scss" scoped>
    button.btncomponent {
        border: none;
        background-color: #a72c2c!important;
        color: #ffffff!important;
        font-size: 20px;
        border-radius: 0;
        padding: 15px;
        transition: all 0.3s ease;
        border: 2px solid #a72c2c;
        cursor: pointer;
        &:hover {
            color: #a72c2c!important;
            background-color: #ffffff!important;
        }
    }
</style>
